/**
 * 通知层（antd `notification`）的**全局配置**。
 *
 * ## 为什么 toast 要「点击穿透」
 *
 * antd 的 notice 根元素自带 `pointer-events: auto` ⇒ **它会拦截它压住的一切点击**。
 * 通知按用户裁定放在**左下角**（2026-10-23）⇒ 左下角正好是「新增订单」弹窗
 * 「创 建」按钮所在的位置 ⇒ 一条 IMPORTANT 广播就能把提交按钮挡住 8 秒
 * （2026-10-23 真机 e2e 实测：Playwright 报 `intercepts pointer events`，
 * 用例红在「点不动按钮」上，不是红在断言上）。
 *
 * ⇒ 口径：**通知是被动状态播报，不许拦点击**——`root` 关掉命中测试，
 * 只留关闭按钮（`close`）可点（人还是能手动把它关掉）。
 *
 * ⚠️ 代价：antd v6 的 `pauseOnHover` 靠 mouseenter 触发 ⇒ 命中测试关掉后
 * **悬停暂停不再生效**（8 秒到点就走）。取舍理由：挡住按钮 8 秒是**功能不可用**，
 * 少一次悬停暂停只是少读一条消息。
 *
 * ⚠️ `pointer-events` **没有 antd token** ⇒ 只能内联（本树不建 .css，
 * 见 `scripts/check-ui-discipline.mjs`）⇒ 这一处登记在那道闸的登记处里。
 */
export const notificationConfig = {
  /** 同时最多四条；再多就淹掉页面了。 */
  maxCount: 4,
  /** 左下角（用户裁定 2026-10-23）：右上角留给铃铛与顶栏动作区。 */
  placement: 'bottomLeft',
  styles: {
    /** 通知本体不拦点击（见上面的导语）。 */
    root: { pointerEvents: 'none' },
    /** 关闭按钮仍然可点。 */
    close: { pointerEvents: 'auto' },
  },
} as const;
